import React from 'react';
import PropTypes from 'prop-types';
import {
  Alert, Button, Form, Icon, Input
} from 'antd';
import AppLogo from 'library/appLogo';

const FormItem = Form.Item;

class SignIn extends React.Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    visible: PropTypes.bool,
    loading: PropTypes.bool,
    error: PropTypes.string,
    onShowOptionsClick: PropTypes.func,
    onSubmitClick: PropTypes.func
  };

  static defaultProps = {
    visible: true,
    loading: false,
    error: null,
    onShowOptionsClick() {
    },
    onSubmitClick() {
    }
  };

  constructor(props) {
    super(props);

    this.handleShowOptionsClick = this.handleShowOptionsClick.bind(this);
    this.handleSubmitClick = this.handleSubmitClick.bind(this);
  }

  handleShowOptionsClick(e) {
    const { form, onShowOptionsClick } = this.props;
    e.preventDefault();
    form.resetFields();
    onShowOptionsClick();
  }

  handleSubmitClick(e) {
    const { form, onSubmitClick } = this.props;
    e.preventDefault();
    form.validateFields((error, values) => {
      if (!error) {
        onSubmitClick(values);
      }
    });
  }

  render() {
    const {
      visible, loading, error, form
    } = this.props;
    const { getFieldDecorator } = form;

    return (
      <div className={`bhp-login-panel ${visible ? 'bhp-rotateSlideIn' : 'bhp-rotateSlideOut'}`}>
        <div className="bhp-header">
          <AppLogo />
        </div>
        <div className="bhp-content">
          <div className="bhp-title-2 bhp-margin-bottom-1x">Crew Rostering</div>

          <Form onSubmit={this.handleSubmitClick}>
            <FormItem>
              {getFieldDecorator('username', {
                rules: [{
                  required: true,
                  message: 'Please enter your Username.'
                }]
              })(
                <Input prefix={<Icon type="user" />} placeholder="Username" />
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('password', {
                rules: [{
                  required: true,
                  message: 'Please enter your Password.'
                }]
              })(
                <Input prefix={<Icon type="lock" />} type="password" placeholder="Password" autocomplete="off" />
              )}
            </FormItem>
            <Button type="primary" htmlType="submit" loading={loading}>
              Login
            </Button>
          </Form>
          <div>
            Return to
            {' '}
            <a onClick={this.handleShowOptionsClick}>Login Options</a>
          </div>
        </div>
        {error
        && error.length > 0 && (
          <div className="bhp-footer">
            <Alert message="Login Failed" description={error} type="error" />
          </div>
        )}
      </div>
    );
  }
}

export default Form.create()(SignIn);
